// src/store/authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: null,
  roleType: null,
  userId: null,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthData: (state, action) => {
      const { token, roleType, userId } = action.payload;
      state.token = token;
      state.roleType = roleType;
      state.userId = userId;
      state.isAuthenticated = true;
    },

    logout: (state) => {
      state.token = null;
      state.roleType = null;
      state.userId = null;
      state.isAuthenticated = false;
    },
  },
});

export const { setAuthData, logout } = authSlice.actions;
export default authSlice.reducer;
